/* ============================================================
   PŘÍSAHA – globální UI interakce (přeneseno ze _template/site.js).
   Header, footer, nav i lídři se renderují server-side (PHP/ACF),
   tady je jen chování: mobilní off-canvas, megamenu, donate QR drawer.
   ============================================================ */

/* ---- Kotvy: cíl v <details> (program) při navigaci hashem otevřít ---- */
(function () {
  function openFromHash() {
    if (!location.hash) return;
    var el;
    try { el = document.getElementById(decodeURIComponent(location.hash.slice(1))); } catch (e) { return; }
    if (!el) return;
    var d = el.tagName === 'DETAILS' ? el : (el.closest ? el.closest('details') : null);
    if (d && !d.open) { d.open = true; el.scrollIntoView(); }
  }
  window.addEventListener('hashchange', openFromHash);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openFromHash);
  } else {
    openFromHash();
  }
})();

/* ---- Mobilní off-canvas menu ---- */
(function () {
  var mNavEl = document.getElementById('m-nav');
  var mBackdrop = document.getElementById('m-nav-backdrop');
  if (!mNavEl || !mBackdrop) return;

  function openMNav() { mNavEl.classList.add('open'); mBackdrop.classList.add('open'); document.body.style.overflow = 'hidden'; }
  function closeMNav() { mNavEl.classList.remove('open'); mBackdrop.classList.remove('open'); document.body.style.overflow = ''; }

  var burger = document.getElementById('m-burger');
  if (burger) burger.addEventListener('click', openMNav);
  var closeBtn = document.getElementById('m-nav-close');
  if (closeBtn) closeBtn.addEventListener('click', closeMNav);
  mBackdrop.addEventListener('click', closeMNav);

  Array.prototype.forEach.call(mNavEl.querySelectorAll('.navlink'), function (a) {
    if (!a.classList.contains('js-darovat')) a.addEventListener('click', closeMNav);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMNav(); });
})();

/* ---- Megamenu (hover, přilepené k navbaru; časovač řeší přejezd přes mezeru) ---- */
(function () {
  var trig = document.getElementById('nav-o-nas');
  var megaEl = document.getElementById('mega');
  if (!trig || !megaEl) return;

  var timer;
  function openMega() { clearTimeout(timer); megaEl.classList.add('open'); megaEl.setAttribute('aria-hidden', 'false'); }
  function closeMega() { timer = setTimeout(function () { megaEl.classList.remove('open'); megaEl.setAttribute('aria-hidden', 'true'); }, 160); }

  trig.addEventListener('mouseenter', openMega);
  trig.addEventListener('mouseleave', closeMega);
  megaEl.addEventListener('mouseenter', openMega);
  megaEl.addEventListener('mouseleave', closeMega);
  megaEl.addEventListener('click', function () { megaEl.classList.remove('open'); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') megaEl.classList.remove('open'); });
})();

/* ============================================================
   Globální off-canvas – rychlý dar QR platbou.
   Otevře jej jakýkoli prvek s třídou .js-darovat.
   Údaje účtu čte z window.PRISAHA_DONATE (plněno z ACF v PHP).
   Bez vyplněného účtu se QR nevykreslí (žádné hardcoded hodnoty).
   ============================================================ */
(function () {
  var CFG = window.PRISAHA_DONATE || {};
  if (!CFG.account && !CFG.iban) return; // není co darovat -> drawer se nezapíná

  function mod97(s) { var r = 0; for (var i = 0; i < s.length; i++) { r = (r * 10 + (s.charCodeAt(i) - 48)) % 97; } return r; }
  function czIban(prefix, acc, bank) {
    prefix = ('000000' + prefix).slice(-6); acc = ('0000000000' + acc).slice(-10);
    var bban = bank + prefix + acc; var c = 98 - mod97(bban + '123500'); c = ('0' + c).slice(-2);
    return 'CZ' + c + bban;
  }

  // IBAN: buď přímo z ACF, nebo dopočítat z čísla účtu "cislo/kod"
  var IBAN = CFG.iban || '';
  if (!IBAN && CFG.account) {
    var parts = String(CFG.account).split('/');
    var accNum = (parts[0] || '').replace(/\D/g, '');
    var bank = (parts[1] || '').replace(/\D/g, '');
    var pref = '';
    if (accNum.indexOf('-') === -1 && parts[0] && parts[0].indexOf('-') !== -1) { }
    if (parts[0] && parts[0].indexOf('-') !== -1) { var pp = parts[0].split('-'); pref = pp[0].replace(/\D/g, ''); accNum = pp[1].replace(/\D/g, ''); }
    if (accNum && bank) IBAN = czIban(pref, accNum, bank);
  }

  var MSG = CFG.message || '';
  var ocVs = '';   // VS aktuálního daru (např. výzva Rozsviťme) – nastavuje openDrawer
  var ocMsg = MSG; // zpráva aktuálního daru
  var ocProjMsg = '';    // předvyplněná zpráva projektu (z data-msg)
  var ocMesto = '';      // název města (z data-mesto)
  var ocMestoOnly = false; // true = návštěvník zvolil „přispět městu" (zpráva se vymaže)
  var amounts = (CFG.amounts && CFG.amounts.length)
    ? CFG.amounts.map(function (x) { return parseInt(x, 10) || 0; }).filter(Boolean)
    : [200, 500, 1000, 2000, 5000];
  var ocAmt = amounts[Math.min(2, amounts.length - 1)] || amounts[0];

  // SPAYD + bundlovaný QR encoder (1 bajt/znak): zprávu skládáme do ASCII —
  // diakritika pryč (NFD + odstranění kombinujících znaků), ostatní ne-ASCII pryč,
  // `*` je oddělovač SPAYD (mezera), `%` musí být kódováno jako %25.
  function spaydMsg(s) {
    var t = String(s || '');
    if (t.normalize) t = t.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return t.replace(/\*/g, ' ').replace(/%/g, '%25').replace(/[^\x20-\x7E]/g, '').replace(/\s+/g, ' ').trim().slice(0, 60);
  }

  function spayd(a) {
    var s = 'SPD*1.0*ACC:' + IBAN + '*AM:' + a.toFixed(2) + '*CC:CZK';
    if (ocVs) s += '*X-VS:' + ocVs;
    var m = spaydMsg(ocMsg);
    if (m) s += '*MSG:' + m;
    return s;
  }

  var markup =
    '<div id="oc-backdrop" class="oc-backdrop"></div>' +
    '<aside id="oc" class="oc" role="dialog" aria-modal="true" aria-label="Darovat QR platbou" aria-hidden="true">' +
      '<div class="oc-head">' +
        '<div><div class="lbl" id="oc-kicker" style="margin-bottom:4px">Rychlá platba</div>' +
        '<div class="disp" style="font-size:22px;color:var(--navy)">Darovat QR kódem</div></div>' +
        '<button class="oc-x" id="oc-close" aria-label="Zavřít"><i class="fa-light fa-xmark" style="font-size:24px" aria-hidden="true"></i></button>' +
      '</div>' +
      '<div class="oc-body">' +
        '<div class="lbl" style="margin-bottom:10px;color:var(--muted)">Vyberte částku</div>' +
        '<div id="oc-chips" style="display:flex;gap:8px;flex-wrap:wrap;margin-bottom:12px"></div>' +
        '<div style="position:relative;margin-bottom:24px">' +
          '<input id="oc-amt" type="number" min="1" inputmode="numeric" style="width:100%;padding:14px 56px 14px 14px;border:1.5px solid var(--line);border-radius:2px;font-family:var(--mono);font-size:20px;background:var(--bg);outline:none">' +
          '<span class="mono" style="position:absolute;right:16px;top:50%;transform:translateY(-50%);color:var(--muted);font-size:15px">Kč</span>' +
        '</div>' +
        '<label class="lbl" for="oc-msg-in" style="display:block;margin-bottom:6px">Zpráva pro příjemce</label>' +
        '<input id="oc-msg-in" type="text" maxlength="60" placeholder="např. název projektu (nepovinné)" style="width:100%;padding:12px 14px;border:1.5px solid var(--line);border-radius:2px;font-family:var(--mono);font-size:14px;background:var(--bg);outline:none;margin-bottom:24px">' +
        '<label id="oc-mesto-wrap" style="display:none;align-items:flex-start;gap:10px;margin:-14px 0 24px;font-size:var(--fs-sm);color:var(--ink);cursor:pointer"><input id="oc-mesto" type="checkbox" style="margin-top:3px"><span id="oc-mesto-lbl"></span></label>' +
        '<div class="oc-qrwrap"><div id="oc-qr" class="oc-qr"></div>' +
          '<div class="mono" style="font-size:11px;color:var(--muted);text-align:center;margin-top:14px;line-height:1.5">Naskenujte v mobilní bankovní aplikaci<br>(QR Platba / SPAYD)</div></div>' +
        '<div class="oc-details">' +
          '<div class="row" id="oc-pro-row" style="display:none"><span class="lbl">Příspěvek pro</span><span class="val" id="oc-pro"></span></div>' +
          (CFG.account ? '<div class="row"><span class="lbl">Účet</span><span class="mono val">' + CFG.account + '</span></div>' : '') +
          '<div class="row"><span class="lbl">IBAN</span><span class="mono val" id="oc-iban">-</span></div>' +
          '<div class="row" id="oc-vs-row" style="display:none"><span class="lbl">VS</span><span class="mono val" id="oc-vs"></span></div>' +
          '<div class="row" style="border-bottom:none"><span class="lbl">Částka</span><span class="mono val" id="oc-sum" style="color:var(--red);font-weight:600">-</span></div>' +
        '</div>' +
      '</div>' +
    '</aside>';

  var holder = document.createElement('div');
  holder.innerHTML = markup;
  while (holder.firstChild) document.body.appendChild(holder.firstChild);

  var elOc = document.getElementById('oc');
  var elAmt = document.getElementById('oc-amt');

  function renderChips() {
    document.getElementById('oc-chips').innerHTML = amounts.map(function (a) {
      return '<button class="oc-amt-chip' + (a === ocAmt ? ' active' : '') + '" data-a="' + a + '">' + a.toLocaleString('cs-CZ') + '</button>';
    }).join('');
  }
  function render() {
    if (document.activeElement !== elAmt) elAmt.value = ocAmt || '';
    var ibEl = document.getElementById('oc-iban'); if (ibEl) ibEl.textContent = IBAN || '-';
    document.getElementById('oc-sum').textContent = (ocAmt || 0).toLocaleString('cs-CZ') + ' Kč';
    var vsRow = document.getElementById('oc-vs-row');
    if (vsRow) { vsRow.style.display = ocVs ? '' : 'none'; document.getElementById('oc-vs').textContent = ocVs; }
    // „Příspěvek pro" — vyplněná zpráva = projekt, prázdná = město (jen u darů s VS)
    var proRow = document.getElementById('oc-pro-row');
    if (proRow) {
      var proTxt = ocMsg ? ocMsg : ocMesto;
      if (ocVs && proTxt) {
        proRow.style.display = '';
        document.getElementById('oc-pro').textContent = proTxt;
      } else {
        proRow.style.display = 'none';
        document.getElementById('oc-pro').textContent = '';
      }
    }
    renderChips();
    var box = document.getElementById('oc-qr');
    if (typeof qrcode !== 'function') {
      box.innerHTML = '<div class="mono" style="font-size:11px;color:var(--muted);text-align:center">QR se načítá…<br>Použijte údaje níže.</div>';
    } else if (ocAmt > 0 && IBAN) {
      var qr = qrcode(0, 'M'); qr.addData(spayd(ocAmt)); qr.make();
      box.innerHTML = qr.createImgTag(6, 0);
    } else {
      box.innerHTML = '<div class="mono" style="font-size:11px;color:var(--muted)">Zadejte částku</div>';
    }
  }
  // opts = {vs, msg, mesto}. Dar z detailu projektu má zprávu předvyplněnou názvem projektu,
  // dar z města startuje s prázdnou zprávou (příspěvek patří městu jako celku).
  window.openDrawer = function (a, opts) {
    ocVs = (opts && opts.vs) || '';
    ocProjMsg = (opts && opts.msg) || '';
    ocMesto = (opts && opts.mesto) || '';
    ocMestoOnly = false;
    ocMsg = ocProjMsg || (ocVs ? '' : MSG);
    var mi = document.getElementById('oc-msg-in');
    if (mi) { mi.value = ocMsg; mi.disabled = false; }
    // Volba „přispět městu" dává smysl jen tehdy, když je zpráva předvyplněná projektem
    var mw = document.getElementById('oc-mesto-wrap');
    var mc = document.getElementById('oc-mesto');
    if (mc) mc.checked = false;
    if (mw) {
      if (ocProjMsg && ocMesto) {
        var tpl = CFG.mestoLabel || 'Chci přispět městu {mesto} jako celku';
        document.getElementById('oc-mesto-lbl').textContent = tpl.split('{mesto}').join(ocMesto);
        mw.style.display = 'flex';
      } else {
        document.getElementById('oc-mesto-lbl').textContent = '';
        mw.style.display = 'none';
      }
    }
    // Hlavička draweru: u darů kampaně (VS) popisek z ACF, jinak výchozí text.
    var kick = document.getElementById('oc-kicker');
    if (kick) kick.textContent = (ocVs && CFG.rcKicker) ? CFG.rcKicker : 'Rychlá platba';
    if (a) ocAmt = a;
    render();
    elOc.classList.add('open');
    document.getElementById('oc-backdrop').classList.add('open');
    elOc.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  };
  window.closeDrawer = function () { elOc.classList.remove('open'); document.getElementById('oc-backdrop').classList.remove('open'); elOc.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; };

  document.getElementById('oc-close').addEventListener('click', window.closeDrawer);
  document.getElementById('oc-backdrop').addEventListener('click', window.closeDrawer);
  elAmt.addEventListener('input', function () { ocAmt = parseInt(this.value, 10) || 0; render(); });
  var elMsg = document.getElementById('oc-msg-in');
  if (elMsg) elMsg.addEventListener('input', function () { ocMsg = this.value.replace(/\*/g, ' ').slice(0, 60); render(); });
  var elMesto = document.getElementById('oc-mesto');
  if (elMesto) elMesto.addEventListener('change', function () {
    ocMestoOnly = !!this.checked;
    ocMsg = ocMestoOnly ? '' : ocProjMsg;
    var mi = document.getElementById('oc-msg-in');
    if (mi) { mi.value = ocMsg; mi.disabled = ocMestoOnly; }
    render();
  });
  document.getElementById('oc-chips').addEventListener('click', function (e) { var b = e.target.closest('[data-a]'); if (!b) return; ocAmt = parseInt(b.getAttribute('data-a'), 10); render(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') window.closeDrawer(); });
  document.addEventListener('click', function (e) { var t = e.target.closest('.js-darovat'); if (t) { e.preventDefault(); window.openDrawer(parseInt(t.getAttribute('data-castka'), 10) || 0, { vs: t.getAttribute('data-vs') || '', msg: t.getAttribute('data-msg') || '', mesto: t.getAttribute('data-mesto') || '' }); } });
  render();
})();
